// extracted by mini-css-extract-plugin
export var defaultWrapper = "_hg-3";
export var downloadButton = "_hg-4";
export var fileContainer = "_hg-9 _hg-7";
export var fileContainerBase = "_hg-7";
export var fileContainerFixedHeight = "_hg-8 _hg-7";
export var fileInfo = "_hg-5";
export var fileInfoWidthRestricted = "_hg-6";
export var fileType = "_hg-1";
export var fileTypeName = "_hg-2";
export var image = "_hg-0";
export var link = "_hg-b";
export var overflowEllipsis = "_hg-a";